import type { RouteRecordNormalized, RouteRecordRaw } from "vue-router"

/**
 * 根据路径获取所需的权限
 * @param routes 路由列表
 * @param path 路由路径
 * @returns 该路径及其父路径所需的权限列表
 */
export function getPermissionsByPath(routes: RouteRecordNormalized[], path: string): string[] {
  const permissions: string[] = []

  function findRouteAndCollectPermissions(routes: RouteRecordRaw[], targetPath: string) {
    for (const route of routes) {
      // 创建一个更精确的正则表达式来匹配路由路径
      const routePathRegex = new RegExp(`^${route.path.replace(/\//g, "\\/").replace(/:\w+/g, "[^\\/]+")}(\\/|$)`)
      if (routePathRegex.test(targetPath)) {
        if (route.meta?.permissions) {
          permissions.push(...route.meta.permissions)
        }
      }
    }
    return permissions
  }

  return findRouteAndCollectPermissions(routes, path)
}

/**
 * 获取指定路径的扩展权限
 * @param routes 路由列表
 * @param path 路由路径
 * @returns 该路径的扩展权限数组，如果不存在则返回空数组
 */
export function getExtPermissionsByPath(routes: RouteRecordNormalized[], path: string): ExtPermission[] {
  const extPermissions: ExtPermission[] = []
  function findRouteAndGetExtPermissions(routes: RouteRecordRaw[], targetPath: string): ExtPermission[] {
    for (const route of routes) {
      // 创建一个更精确的正则表达式来匹配路由路径
      const routePathRegex = new RegExp(`^${route.path.replace(/\//g, "\\/").replace(/:\w+/g, "[^\\/]+")}(\\/|$)`)
      if (routePathRegex.test(targetPath)) {
        if (route.meta?.extPermissions) {
          extPermissions.push(...route.meta.extPermissions)
        }
      }
    }
    return extPermissions
  }

  return findRouteAndGetExtPermissions(routes, path)
}
